import { render, staticRenderFns } from "./AnyConcernsOrProblems.vue?vue&type=template&id=2b7e2888&scoped=true"
import script from "./AnyConcernsOrProblems.vue?vue&type=script&lang=js"
export * from "./AnyConcernsOrProblems.vue?vue&type=script&lang=js"
import style0 from "./AnyConcernsOrProblems.vue?vue&type=style&index=0&id=2b7e2888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e2888",
  null
  
)

export default component.exports